<template>
  <div class="fin-faq">
    <Retailnavbar> </Retailnavbar>
    <div class="main-page">
      <div class="section-1">FAQ</div>
      <!-- <FaqComponent></FaqComponent> -->
      <div class="section-2">
        <!-- <el-row>
          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">&nbsp;</el-col>
          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
            <div class="market-section">
              <div class="tabs" :class="[
                selectedMarketType == 'equity'
                  ? 'btn-theme-gradient'
                  : 'tabs',
              ]" @click="changeTab('equity')">
                Equity
              </div>
              <div class="tabs" :class="[
                selectedMarketType == 'options'
                  ? 'btn-theme-gradient'
                  : 'tabs',
              ]" @click="changeTab('options')">
                Options
              </div>
            </div>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
            <div class="right-tabs-main">
              <div
                class="left-side"
                v-for="(link, index) in links"
                :key="index"
              >
                <div
                  class="tab-btn flex"
                  @click="active_faq_type = link"
                  :class="[
                    active_faq_type == link ? 'active-tab-btn' : 'tab-btn',
                  ]"
                >
                  <div>{{ link }}</div>
                  <div>+</div>
                </div>
              </div>
            </div>
          </el-col>

          <el-col
            :xs="24"
            :sm="24"
            :md="15"
            :lg="15"
            :xl="15"
            v-loading="isFaqLoading"
          >
            <div v-if="selectedMarketType == 'equity'">
              <div class="faq-right" v-if="active_faq_type == 'General'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts is a marketplace for price estimates. We are a
                    service provider for price estimate tracking and
                    aggregation, enabling retail users to make investment
                    decisions.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Premium?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts Premium is One Click Access to Bundle of SEBI
                    Registered experts’ recommendations/strategies
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How can StockAnts benefit me as a retail user</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts is a marketplace for price estimates. We aggregate
                    price estimates from SEBI registered experts to help retail
                    users to make an investment decision & trade with their
                    broker
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      How is StockAnts different from other financial apps or
                      advisory services platform?
                    </li>
                  </ul>
                  <p class="faq-p">
                    We provide data published by bundle of SEBI Registered
                    experts instead of one, making it more cost-effective
                    subscription.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How to sign up on StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    A retail user can sign in using broker credentials (Listed)
                    or sign-up using Email or Gmail.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How to connect my broker account with StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    You can login on StockAnts through broker’s demat account
                    credentials & broker account will be connected.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      I Have Forgotten or Want to Change my Password. What
                      should I Do?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can reset password using ‘forgot password’ on login
                    page.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>I am a beginner, which feature should I use?</li>
                  </ul>
                  <p class="faq-p">
                    Being a beginner, you can discover strategies published by
                    SEBI registered experts under expert view & even validate
                    your ideas using the StockAnts Sentiment Card.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      How to validate idea for trade and investment on
                      StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Retail user has to search stock, check StockAnts Sentiment
                    Card, price estimate given by SEBI Registered experts and
                    trade with broker using your user credentials.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Why should I rely on SEBI Registered experts displayed on
                      StockAnts to decide on trade/Investment?
                    </li>
                  </ul>
                  <p class="faq-p">
                    StockAnts delivers the data of SEBI registered experts in
                    as-is format. We verify the documents such as Aadhar Card,
                    Pan Card before onboarding an expert. SEBI Registered Expert
                    also needs to fulfill the eligibility criteria to get
                    visibility on StockAnts.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Can I check SEBI Registered Expert’s Track record?</li>
                  </ul>
                  <p class="faq-p">
                    On StockAnts we help with track and trust before deciding on
                    trade. Each SEBI Registered expert's performance, stock-wise
                    and sector-wise can be checked from the SEBI Registered
                    expert’s cover page.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How can I get notification?</li>
                  </ul>
                  <p class="faq-p">
                    User can bookmark/ follow any recommendation/ strategy &
                    later on, can get notifications of any
                    recommendations/strategies.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Where can I find bookmarked/followed strategies?</li>
                  </ul>
                  <p class="faq-p">
                    User can find bookmarked/followed strategies under
                    watchlist.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Can I reach SEBI Registered expert on StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    Yes, you can connect with the SEBI Registered expert using
                    any of their social media handles displayed on the cover
                    page.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Which strategies can be discovered on StockAnts platform?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can discover strategies of a few specific indices like
                    Bank Nifty, Nifty 50, Fin-nifty.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Is StockAnts SEBI compliant?
                    </li>
                  </ul>
                  <p class="faq-p">
                    StockAnts works as a bridge between brokers and
                    SEBI-registered advisors (RAs), implying that they operate
                    within the regulatory framework established by the
                    Securities and Exchange Board of India (SEBI)​ . This
                    suggests that their operations are aligned with SEBI
                    regulations, ensuring compliance and reliability for their
                    users.
                  </p>
                </div>
              </div>

              <div class="faq-right" v-if="active_faq_type == 'Trade'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I trade on StockAnts? Are there any charges for
                      trading directly from StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    It isn’t possible to trade on StockAnts directly as we
                    aren’t a broker, but you can connect your broker’s demat
                    account & trade through the same. StockAnts does not charge
                    anything for trading. All you need to pay is your brokerage
                    to the broker for trading.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      If I login with my broker credentials, how secure is my
                      DMAT account holdings and funds?
                    </li>
                  </ul>
                  <p class="faq-p">
                    On StockAnts retail user can place order with own broker and
                    can see holdings, order positions and funds available. We
                    have partnered with the brokers and your data is 100% secure
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I add funds in my DMAT A/c from StockAnts to trade?
                    </li>
                  </ul>
                  <p class="faq-p">
                    No, you need to add funds from your broker platform only.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      If a user has demat accounts of multiple broker which are
                      connected on StockAnts, then user should trade which demat
                      account?
                    </li>
                  </ul>
                  <p class="faq-p">
                    StockAnts doesn’t promote any Broker, but StockAnts suggests
                    to trade via that broker’s demat account which charges
                    lesser or no brokerage so that user can earn more profit.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I trade a complete strategy as a basket?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can trade on a single leg from the complete strategy
                    published by an expert. Feature of trading a complete
                    strategy is coming soon.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      What should I do when the stock price is already above the
                      entry price when I attempt to buy or sell?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can still trade on that particular
                    recommendation/strategy by checking remaining potential on
                    the same.
                  </p>
                </div>

                <div class="brokerage-calculator-section">
                  <div class="faded-border-bottom"></div>
                  <h1 class="brokerage-head">Brokerage Calculator terms.</h1>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Securities/Commodities transaction tax</li>
                    </ul>
                    <p class="faq-p">
                      Tax by the government when transacting on the exchanges.
                      Charged are on both buy and sell sides when trading equity
                      delivery. Charged only on selling side when trading
                      intraday or on F&O.
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Transaction/Turnover Charges</li>
                    </ul>
                    <p class="faq-p">
                      Charged by exchanges (NSE, BSE, MCX) on the value of your
                      transactions (total of buy & sell amount)
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Stamp Duty</li>
                    </ul>
                    <p class="faq-p">
                      Stamp Duty charges by the Government of India as per the
                      Indian Stamp Act of 1899 for transacting in instruments on
                      the stock exchanges and depositories.
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>GST</li>
                    </ul>
                    <p class="faq-p">
                      Tax levied by the government on the services rendered. 18%
                      of (brokerage + SEBI charges + transaction charges)
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>SEBI Charges</li>
                    </ul>
                    <p class="faq-p">
                      Charged at ₹10 per crore + GST by Securities and Exchange
                      Board of India for regulating the markets.
                    </p>
                  </div>

                  <div class="faq-table">
                    <table>
                      <tr>
                        <th>&nbsp;</th>
                        <th>Equity delivery</th>
                        <th>Equity intraday</th>
                        <th style="border-right: none;">F&O - Options</th>
                      </tr>
                      <tr>
                        <td>STT/CTT</td>
                        <td>0.1% on buy & sell</td>
                        <td>0.025% on the sell side</td>
                        <td style="border-right: none;">
                          <div>
                            0.125% of the intrinsic value on options that are
                            bought and exercised
                          </div>
                          <div>0.0625% on sell side (on premium)</div>
                        </td>
                      </tr>
                      <tr>
                        <td>Transaction charges</td>
                        <td>
                          <div>NSE: 0.00325%</div>
                          <div>BSE: 0.00375%</div>
                        </td>
                        <td>
                          <div>NSE: 0.00325%</div>
                          <div>BSE: 0.00375%</div>
                        </td>
                        <td style="border-right: none;">
                          <div>NSE: 0.05% (on premium)</div>
                          <div>BSE: 0.005% (on premium)</div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          GST
                        </td>
                        <td>
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                        <td>
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                        <td style="border-right: none;">
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                      </tr>

                      <tr>
                        <td>
                          SEBI charges
                        </td>
                        <td>₹10 / crore + GST</td>
                        <td>₹10 / crore + GST</td>
                        <td style="border-right: none;">₹10 / crore + GST</td>
                      </tr>

                      <tr>
                        <td>
                          Stamp Duty charges
                        </td>
                        <td>0.015% or ₹1500 / crore on buy side</td>
                        <td>0.003% or ₹300 / crore on buy side</td>
                        <td style="border-right: none;">
                          0.003% or ₹300 / crore on buy side
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div
                class="faq-right"
                v-if="active_faq_type == 'StockAnts Terms'"
              >
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How is the Success rate calculated?</li>
                  </ul>
                  <p class="faq-p">
                    Success rate is defined as the achievement of the target
                    price within the chosen time frame. If ROI of a particular
                    recommendation is positive then success rate will be 100% &
                    if ROI is negative, success rate will be 0%
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What are AntEstimates and how it is calculated?</li>
                  </ul>
                  <p class="faq-p">
                    AntEstimates represent the collective view or consensus of
                    the market based on the various estimates provided by the
                    investor community. The data cleansing algorithms weed out
                    frivolous estimates and utilize the normalized data to
                    arrive at the market consensus.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      How to read a performance wheel?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Performance is measured by two critical parameters, Success
                    Rate on achieving the target estimate provided and Accuracy
                    based on the variance of the estimates from the Actual
                    Market prices at the end of the estimated period (Week/
                    Month/ Quarter). The Performance Wheel indicates the
                    achievement of the target in a number of days and the
                    potential to achieve more returns over the estimated period.
                    Recommendation status in performance wheel depicts target
                    achieved, target not achieved, recommendation updated,
                    recommendation closed, live recommendation, yet to live and
                    stop-loss triggered.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      What is the difference between a total recommendation and
                      live recommendations?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Recommendations are considered ‘live’ the target is not
                    achieved or till the elapse of the time period for which the
                    estimate is provided.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      What is the difference between a total strategy and live
                      strategy?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Strategies are considered ‘live’ the target is not achieved
                    or till the elapse of the time period for which the estimate
                    is provided.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      What are the different target periods on StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Stockants has intraday. It considers Weekly, Monthly,
                    estimates as Short Term. It considers Quarterly and 6months
                    price estimates as Midterm. Any target period above 6 months
                    will be considered as long term.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is Breakeven range in options trading?</li>
                  </ul>
                  <p class="faq-p">
                    The break-even price for an options contract will be the
                    strike price plus the cost of the premium. In short where
                    the profit and loss is zero is the breakeven price.
                  </p>
                </div>
              </div>

              <div class="faq-right" v-if="active_faq_type == 'Plans'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Lite Plan?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts Lite plan is a free plan. You get Access to 40+
                    Recommendations & Strategies Free
                    <a href="/plans">Check Plans.</a>
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Day Plan?</li>
                  </ul>
                  <p class="faq-p">
                    Day pass gives you first hands-on experience of StockAnts.
                    We don’t want to oblige users to subscribe for 1 month and
                    make it obligatory to use StockAnts platform. Users can
                    checkout StockAnts platform as when required without any
                    commitment and decide on trade and investment.
                    <a href="/plans">Check Plans.</a>
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Premium?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts Premium plan is access to SEBI Registered expert’s
                    recommendations with Price estimate tracking. StockAnts
                    premium includes unlimited access to SEBI Registered experts
                    recommendations and Price estimate tracking with more than
                    20 filters, trading cost estimator, market sentiment.
                    <a href="/plans">Check Plans.</a>
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What are the various modes of payment?</li>
                  </ul>
                  <p class="faq-p">
                    You can pay online using QR code, UPI, Credit Card, Debit
                    Card or Net Banking.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Does StockAnts provide free access to the platform?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts are connected with a lot of brokers. Users can get
                    free access to the platform by logging in through a few
                    brokers.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      How can I get to know through which broker can I access
                      StockAnts free of cost?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Users can check it on login page. Users can find ‘free’ tab
                    along with a few brokers icon.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>When will my premium access get activated?</li>
                  </ul>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      I have made the payment, but Premium access is not
                      reflecting?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can re-login on the platform or please contact the
                    customer support team with payment & premium access
                    offering.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How do I check my subscription end date?</li>
                  </ul>
                  <p class="faq-p">
                    To know the subscription end date, kindly go to ‘my account’
                    on desktop or go to ‘plans’ on mobile.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is refund policy?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts strictly has no refund policy.
                  </p>
                </div>
              </div>
            </div>

            <!-- <div v-if="selectedMarketType == 'options'">
              <div class="faq-right" v-if="active_faq_type == 'General'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How to sign up on StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    A retail user can sign in using broker credentials (Listed)
                    or sign-up using Email or Gmail.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How can StockAnts benefit me as a retail user?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts is a marketplace for price estimates. We aggregate
                    price estimates from market experts to help retail users
                    decide on trade and Investment.
                  </p>
                </div>

                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      How to validate idea for trade and investment on
                      StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Retail user has to search stock, check StockAnts Sentiment
                    Card, price estimate given by experts and trade with broker
                    using your user credentials.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Can I check Expert’s Track record?</li>
                  </ul>
                  <p class="faq-p">
                    On StockAnts we help with track and trust before deciding on
                    trade. Each expert's past track record, stock-wise and
                    sector-wise can be checked from the expert performance page.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Why should I rely on StockAnts expert to decide on
                      trade/Investment?
                    </li>
                  </ul>
                  <p class="faq-p">
                    StockAnts delivers the data of SEBI registered experts. We
                    verify the documents such as Aadhar Card, Pan Card before
                    onboarding an expert. Expert also needs to fulfill the
                    eligibility criteria to get visibility on expert hub.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I reach market expert on StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Yes, you can give review or connect with the expert from the
                    cover page.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Why should I trade options?</li>
                  </ul>
                  <p class="faq-p">
                    Options give you higher returns than equities and mutual
                    funds, in a faster time frame. They are less risky compared
                    to futures and require lower funds. In Options Strategies,
                    your maximum profit and loss are limited. So, no matter what
                    happens, even in a market crash, your losses are fixed to a
                    small number, and you have complete peace of mind.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Why should I trust StockAnts? How safe is StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    StockAnts comes to you through an official partnership with
                    a legally binding agreement between StockAnts and your
                    broker. Before we launch on a broker, we undergo checks from
                    the broker's technology team, IT security team, compliance
                    team, product team, etc. Your money is in very safe hands -
                    yours. We do not have access to your funds - it stays in
                    your broking account.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>I am a beginner, which feature should I use?</li>
                  </ul>
                  <p class="faq-p">
                    Being a beginner, you can discover strategies published by
                    SEBI registered experts under Expert View tab & even
                    validate your ideas using the market sentiment.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Which strategies can be discovered on StockAnts platform?
                    </li>
                  </ul>
                  <p class="faq-p">
                    You can discover strategies of a few specific indices like
                    Bank Nifty, Nifty 50, Fin-nifty.
                  </p>
                </div>
              </div>

              <div class="faq-right" v-if="active_faq_type == 'Trade'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I trade on StockAnts? Are there any charges for
                      trading directly from StockAnts?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Yes, you can trade on StockAnts via your broker. StockAnts
                    does not charge anything for trading directly from the
                    platform. All you need to pay is your brokerage to the
                    broker for trading.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      If I login with my broker credentials, how secure is my
                      DMAT account holdings and funds?
                    </li>
                  </ul>
                  <p class="faq-p">
                    On StockAnts retail user can place order with own broker and
                    can see holdings, order positions and funds available. We
                    have partnered with the brokers and your data is 100%
                    secure.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      Can I add funds in my DMAT A/c from StockAnts to trade?
                    </li>
                  </ul>
                  <p class="faq-p">
                    No, you need to add funds from your broker platform only.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>Can I trade a complete strategy as a basket?</li>
                  </ul>
                  <p class="faq-p">
                    You can trade on a single leg from the complete strategy
                    published by an expert. Feature of trading a complete
                    strategy is coming soon.
                  </p>
                </div>

                <div class="brokerage-calculator-section">
                  <div class="faded-border-bottom"></div>
                  <h1 class="brokerage-head">Brokerage Calculator terms.</h1>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Securities/Commodities transaction tax</li>
                    </ul>
                    <p class="faq-p">
                      Tax by the government when transacting on the exchanges.
                      Charged are on both buy and sell sides when trading equity
                      delivery. Charged only on selling side when trading
                      intraday or on F&O.
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Transaction/Turnover Charges</li>
                    </ul>
                    <p class="faq-p">
                      Charged by exchanges (NSE, BSE, MCX) on the value of your
                      transactions (total of buy & sell amount)
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>Stamp Duty</li>
                    </ul>
                    <p class="faq-p">
                      Stamp Duty charges by the Government of India as per the
                      Indian Stamp Act of 1899 for transacting in instruments on
                      the stock exchanges and depositories.
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>GST</li>
                    </ul>
                    <p class="faq-p">
                      Tax levied by the government on the services rendered. 18%
                      of (brokerage + SEBI charges + transaction charges)
                    </p>
                  </div>

                  <div class="special-sec" style="margin-top: 0">
                    <ul>
                      <li>SEBI Charges</li>
                    </ul>
                    <p class="faq-p">
                      Charged at ₹10 per crore + GST by Securities and Exchange
                      Board of India for regulating the markets.
                    </p>
                  </div>

                  <div class="faq-table">
                    <table>
                      <tr>
                        <th>&nbsp;</th>
                        <th>Equity delivery</th>
                        <th>Equity intraday</th>
                        <th style="border-right: none;">F&O - Options</th>
                      </tr>
                      <tr>
                        <td>STT/CTT</td>
                        <td>0.1% on buy & sell</td>
                        <td>0.025% on the sell side</td>
                        <td style="border-right: none;">
                          <div>
                            0.125% of the intrinsic value on options that are
                            bought and exercised
                          </div>
                          <div>0.0625% on sell side (on premium)</div>
                        </td>
                      </tr>
                      <tr>
                        <td>Transaction charges</td>
                        <td>
                          <div>NSE: 0.00325%</div>
                          <div>BSE: 0.00375%</div>
                        </td>
                        <td>
                          <div>NSE: 0.00325%</div>
                          <div>BSE: 0.00375%</div>
                        </td>
                        <td style="border-right: none;">
                          <div>NSE: 0.05% (on premium)</div>
                          <div>BSE: 0.005% (on premium)</div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          GST
                        </td>
                        <td>
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                        <td>
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                        <td style="border-right: none;">
                          18% on (brokerage + SEBI charges + transaction
                          charges)
                        </td>
                      </tr>

                      <tr>
                        <td>
                          SEBI charges
                        </td>
                        <td>₹10 / crore + GST</td>
                        <td>₹10 / crore + GST</td>
                        <td style="border-right: none;">₹10 / crore + GST</td>
                      </tr>

                      <tr>
                        <td>
                          Stamp Duty charges
                        </td>
                        <td>0.015% or ₹1500 / crore on buy side</td>
                        <td>0.003% or ₹300 / crore on buy side</td>
                        <td style="border-right: none;">
                          0.003% or ₹300 / crore on buy side
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div
                class="faq-right"
                v-if="active_faq_type == 'StockAnts Terms'"
              >
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How is the Success rate calculated?</li>
                  </ul>
                  <p class="faq-p">
                    Success at StockAnts is defined as the achievement of the
                    target price within the chosen time frame. We recommend
                    using the Success Rate for a true evaluation of performance.
                    If CMP is 100/- and your estimate for the week is 115/-, If
                    the target is achieved during the week success rate will be
                    100%. If the price does not reach the target price success
                    rate will be 0%.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>How to read a performance wheel?</li>
                  </ul>
                  <p class="faq-p">
                    Performance is measured by one critical parameter- Success
                    Rate.The Performance Wheel indicates the achievement of the
                    target in a number of days and the potential to achieve more
                    returns over the estimated period. Strategy status in
                    performance wheel depicts strategy achieved, strategy not
                    achieved, strategy updated, strategy incomplete, live
                    strategy, yet to live and stop-loss triggered.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>
                      What is the difference between a total strategy and live
                      strategy?
                    </li>
                  </ul>
                  <p class="faq-p">
                    Strategies are considered ‘live’ the target is not achieved
                    or till the elapse of the time period for which the estimate
                    is provided.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What are the different target periods on StockAnts?</li>
                  </ul>
                  <p class="faq-p">
                    Stockants has intraday. It considers Weekly, Monthly,
                    estimates as Short Term. It considers Quarterly and 6months
                    price estimates as Midterm. Any target period above 6 months
                    will be considered as long term.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is expected capital?</li>
                  </ul>
                  <p class="faq-p">
                    Expected capital or Capital Required is the minimum
                    investment required to execute trade of a particular
                    strategy.
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is Breakeven range in options trading?</li>
                  </ul>
                  <p class="faq-p">
                    The break-even price for an options contract will be the
                    strike price plus the cost of the premium. In short where
                    the profit and loss is zero is the breakeven price.
                  </p>
                </div>
              </div>

              <div class="faq-right" v-if="active_faq_type == 'Plans'">
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Lite Plan?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts Lite plan is a free plan. Benefits -<a
                      href="/plans"
                      >Check Plans.</a
                    >
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Day Plan?</li>
                  </ul>
                  <p class="faq-p">
                    Day pass gives you first hands-on experience of StockAnts.
                    We don’t want to oblige users to subscribe for 1 month and
                    make it obligatory to use StockAnts platform. Users can
                    checkout StockAnts platform as when required without any
                    commitment and decide on trade and investment.<a
                      href="/plans"
                      >Check Plans.</a
                    >
                  </p>
                </div>
                <div class="special-sec" style="margin-top: 0">
                  <ul>
                    <li>What is StockAnts Premium?</li>
                  </ul>
                  <p class="faq-p">
                    StockAnts Premium plan is access to market expert’s
                    strategies with insightful Price estimate tracking. StockAnts
                    premium includes benefits unlimited access to market
                    expert’s strategies with Price estimate tracking with a lot
                    filter stack, Unrestricted access to market, and StockAnts
                    performers with data insight based on performance
                    metrics. Check Plans.
                  </p>
                </div>
              </div>
            </div> -->
          </el-col>
        </el-row>
      </div>
    </div>

    <RetailFooter></RetailFooter>
  </div>
</template>

<script>
import { screenSize } from "../../mixins/ScreenSize.js";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";

export default {
  name: "finFAQ",

  components: { RetailFooter, Retailnavbar },

  mixins: [screenSize],

  data() {
    return {
      active_faq_type: "General",
      links: ["General", "Trade", "StockAnts Terms", "Plans"],
      selectedMarketType: "equity",
      isFaqLoading: false,
      currentUrl: localStorage.getItem("currentUrl")
        ? localStorage.getItem("currentUrl")
        : window.location.href,
    };
  },

  methods: {
    changeTab(current) {
      this.selectedMarketType = current;
      this.isFaqLoading = true;

      setTimeout(() => {
        this.isFaqLoading = false;
      }, 700);
      this.active_faq_type = "General";
    },
  },

  computed: {},
  mounted() {
    // set usertype for redirection
    localStorage.setItem("UserType", "RETAIL INVESTOR");

    // hide plans for bigul
    if (this.currentUrl.includes("bigul.stockants.com")) {
      this.links = ["General", "Trade", "StockAnts Terms"];
    }
  },
};
</script>

<style lang="scss" scoped>
.fin-faq {
  background-color: #fcfcfb;
  padding-bottom: 50px;

  .faded-border-bottom {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(
      radial,
      50% 50%,
      0,
      50% 50%,
      450,
      from(#cac4c4),
      to(#fff)
    );
  }

  .main-page {
    .market-section {
      display: flex;
      margin-left: 10px;

      .tabs {
        font-size: 1rem;
        margin: 5px 10px;
        color: gray;
        font-weight: 600;
        cursor: pointer;
        padding: 3px 15px;
      }
    }

    .section-1 {
      background-image: url("../../assets/images/RetailSideLandingPurple/banner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 400px;
      font-size: 2rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #ffff;
      text-align: center;
      padding-top: 150px;
    }

    .section-2 {
      // padding-left:40px;
      .top-options {
        font-size: 0.9rem;
        font-weight: 500;
        margin-bottom: 60px;
        justify-content: space-around;
        color: rgb(124, 124, 124);

        .tags {
          padding: 7px;
          cursor: pointer;
        }

        .active-tag {
          margin-right: 20px;
          cursor: pointer;
          padding: 7px;
          color: #322e79;
          border-bottom: 2px solid #322e79;
        }
      }

      .faq-right {
        padding-left: 40px;
        border-left: 1px solid #b1afaf;
      }

      .special-sec {
        margin: 0px 0;

        .faq-p {
          margin-left: 40px;
          color: #6d6a6a;

          a {
            font-weight: 600;
            text-decoration: none;
            color: #6da3f3;
          }
        }
      }

      h1 {
        font-size: 1.6rem;
        font-weight: 600;
        color: #25246a;
      }

      p {
        font-size: 0.9rem;
        color: #6d6a6a;
      }

      .right-tabs-main {
        margin-top: 60px;
      }

      .left-side {
        height: 100%;

        .tab-btn {
          justify-content: space-between;
          width: 200px;
          font-weight: 600;
          border: 1px solid;
          padding: 7px 25px;
          margin: 15px auto;
          border-radius: 20px;
          background-color: #ededed;
          border: 1px solid #ededed;
          box-shadow: 0px 8px 9px -9px #716d6d;
          color: gray;
          cursor: pointer;
        }

        .active-tab-btn {
          color: #000;
        }

        .tab-btn:hover {
          background-color: #dfdddd;
          color: #000;
        }
      }

      ul {
        list-style: none;

        li {
          font-size: 1.5rem;
          margin: 10px 0;
          font-weight: 600;
          color: #25246a;
        }

        li::before {
          content: "\2022";
          color: #322e79;
          font-weight: bold;
          width: 1em;
          margin-left: -1em;
          font-size: 45px;
          position: relative;
          margin-right: 25px;
          top: 7px;
        }
      }
    }

    .brokerage-calculator-section {
      margin-top: 40px;

      .brokerage-head {
        padding-top: 15px;
      }

      .faq-table {
        margin-top: 40px;
        border-radius: 10px;
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #d5d5d8 !important;
        border-radius: 10px;

        th {
          border-bottom: 1px solid #d5d5d8;
          color: #a5a6a8;
          font-size: 14px;
          font-weight: 600;
        }

        tr {
          border-bottom: 1px solid #ebeef5;
        }

        td,
        th {
          border-right: 1px solid #d5d5d8;
          padding: 12px 10px;
          text-align: left;
          vertical-align: middle;
        }

        td {
          font-size: 13px;
          color: #000;
          font-weight: 500;
        }

        tr:hover {
          background-color: #eff5fe;
        }
      }
    }

    @media screen and (max-width: 991px) {
      .section-2 .right-tabs-main {
        margin-top: 0px;
      }
    }

    @media screen and (max-width: 876px) {
      .section-1 {
        height: 346px;
        font-size: 1.5rem;
      }

      .section-2 {
        padding: 0 70px;

        .faq-right {
          border-left: none;
        }
      }
    }

    @media screen and (max-width: 600px) {
      .section-1 {
        height: 200px;
        padding-top: 80px;
        font-size: 1.2rem;
      }

      .section-2 {
        padding: 0 35px;

        .faq-right {
          padding-left: 0;
        }

        ul li {
          font-size: 1.1rem;
        }
      }
    }

    @media screen and (max-width: 450px) {
      .section-1 {
        height: 134px;
      }

      .section-2 {
        padding: 0 20px;
      }
    }
  }
}
</style>
